(function() {
  'use strict';
  
  angular
    .module('app.myPolls')
    .controller('ArchiveController', ArchiveController);
      
  ArchiveController.$inject = [
    '$log', 
    '$anchorScroll',
    '$mdDialog',
    '$mdToast',
    '$scope',
    '$state',
    'shell',  
    'myPollsService'
  ];
    
  function ArchiveController(
      $log, 
      $anchorScroll,
      $mdDialog,
      $mdToast,
      $scope, 
      $state,
      shell, 
      myPollsService
    ) {
    $log = $log.getInstance('ArchiveController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.collections = null;
    vm.deleteGroup = deleteGroup;
    vm.deleteCollection = deleteCollection;
    vm.exportResults = exportResults;
    vm.collectionExportResults = collectionExportResults;
    vm.viewResult = viewResult;
    vm.unarchive = unarchive;
    vm.shell = shell;
    
    activate();
    
    function activate() {
      shell.setTitle('Archive');
      myPollsService.getCollections()
      .then(function(collections) {
        vm.collections = _.filter(collections, function(collection) {
          return _.isDate(collection.archived);
        });
      });
      $anchorScroll('top');
    }
    
    function collectionExportResults(collection) {
      exportResults(collection.groups);
    }
    
    function deleteCollection(collection) {
      var indexOfRemoved = vm.collections.indexOf(collection)
      vm.collections.splice(indexOfRemoved, 1);
      myPollsService.deleteCollection(collection);
      $mdToast.show($mdToast.simple()
        .textContent('Collection Sent to Trash')
        .action('UNDO')
        .highlightAction(true)
        .position('bottom right')
      ).then(function(response) {
        if ( response === 'ok' ) {
          vm.collections.splice(indexOfRemoved, 0, collection);
          myPollsService.restoreCollection(collection);
          // TODO restore all groups
        }
      });
    }
    
    function deleteGroup(collectionIndex, group) {
      var groups = vm.collections[collectionIndex].groups;
      var indexOfRemoved = groups.indexOf(group)
      vm.collections[collectionIndex].groups.splice(indexOfRemoved, 1);
      myPollsService.deleteGroup(group);
      $mdToast.show($mdToast.simple()
        .textContent('Group Sent to Trash')
        .action('UNDO')
        .highlightAction(true)
        .position('bottom right')
      ).then(function(response) {
        if ( response === 'ok' ) {
          vm.collections[collectionIndex].groups.splice(indexOfRemoved, 0, group);
          myPollsService.restoreGroup(group);
        }
      });
    }
    
    function exportResults(groups) {
      if (!angular.isArray(groups))
        groups = [groups];
      $mdDialog.show({
        templateUrl: 'app/my-polls/collections/export-results.html',
        controller: 'ExportResultsController as vm',
        clickOutsideToClose: true,        
        locals: { groups: groups }
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
    }
    
    function unarchive(collection) {
      var indexOfRestored = vm.collections.indexOf(collection)
      myPollsService.unarchiveCollection(collection)
      .then(function(){
        vm.collections.splice(indexOfRestored, 1);
      })
      $mdToast.show($mdToast.simple()
        .textContent('Unarchived the Collection')
        .action('UNDO')
        .highlightAction(true)
        .position('bottom right')
      ).then(function(response) {
        if ( response === 'ok' ) {
          vm.collections.splice(indexOfRestored, 0, collection);
          myPollsService.archiveCollection(collection)
        }
      });
    }
    
    function viewResult(poll) {
      $log.debug('viewResult: ', poll._id);
      var resultCallback = function(result) {
        $state.go('result', { resultId: result._id, mode: 'archive' });
      };
      return myPollsService.getLastResult(poll)
        .then(resultCallback)
        .catch(function(err) {
          if (err.code && err.code === 404)
            return myPollsService.createResult(poll).then(resultCallback);
        });
    }
  }
  
})();